import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a5af348"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "新用户", -1))
const _hoisted_2 = { class: "numericalValue" }
const _hoisted_3 = { class: "totalVal" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总用户：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "会员", -1))
const _hoisted_6 = { class: "numericalValue" }
const _hoisted_7 = { class: "totalVal" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总会员：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "今日收益", -1))
const _hoisted_10 = { class: "numericalValue" }
const _hoisted_11 = { class: "totalVal" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总收益：", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "充值成功", -1))
const _hoisted_14 = { class: "numericalValue" }
const _hoisted_15 = { class: "totalVal" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "充值失败:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "待审核", -1))
const _hoisted_18 = { class: "numericalValue" }
const _hoisted_19 = { class: "totalVal" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "审核失败：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "今日楼凤", -1))
const _hoisted_22 = { class: "numericalValue" }
const _hoisted_23 = { class: "totalVal" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总楼凤：", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "充值明显", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "访问详情数次(按照ip分组)", -1))

import { ref, reactive } from 'vue';
import { layer } from '@layui/layui-vue';
import { allStatistics,allPayLog,allAccessLog } from '../../api' 





export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const statistics = reactive({
    totalUsers: "0",
    newUser:"0",
    newMember:"0",
    totalMembers:"0",
    todayEarnings:'0',
    totalRevenue:'0',
    rechargeSuccessful:'0',
    rechargeFailed:'0',
    pendingReview:'0',
    auditFailure:'0',
    todayLoufeng:'0',
    generalLoufeng:'0',
})

 


const getAllStatistics=()=>{

    allStatistics().then((res: any) => {
    if (res != "" && res.code == 0) {  
        statistics.newUser=res.data.newUser;
        statistics.totalUsers=res.data.totalUsers;
        statistics.newMember=res.data.newMember;
        statistics.totalMembers=res.data.totalMembers;
        statistics.todayEarnings=res.data.todayEarnings; 
       statistics.totalRevenue=res.data.totalRevenue; 
       statistics.rechargeSuccessful=res.data.rechargeSuccessful; 
       statistics.rechargeFailed=res.data.rechargeFailed; 
       statistics.pendingReview=res.data.pendingReview; 
       statistics.auditFailure=res.data.auditFailure; 
       statistics.todayLoufeng=res.data.todayLoufeng; 
       statistics.generalLoufeng=res.data.generalLoufeng;  
        
    }
  })

}

getAllStatistics();






const pageAccess = reactive({ current: 1, limit: 10, total: 0 });


const columnsAccess = ref([ 
      { title:"平台", width: "80px", key:"platformId",align:"center" },
      { title:"ip", key:"userName" ,align:"center" }, 
      { title:"账号", key:"userId" ,align:"center" }, 
      { title:"次数", width: "120px", key:"count" ,align:"center" },  
      { title:"时间", key:"addTime" ,align:"center"},
     
    ]);

    const accessdataSource = ref( )


    const changeAccess = (page:any) => {
        getAllAccessLog()
    }

    

    const  getAllAccessLog=()=>{
    var data = { "page": pageAccess.current, "limit": pageAccess.limit};
    allAccessLog(data).then((res: any) => {
    if (res != "" && res.code == 0) {  
        accessdataSource.value=res.data

        pageAccess.total = res.count;
        loading.value = false;
 
        
    }else {
        accessdataSource.value = [];
        pageAccess.total = 0;
              loading.value = false;
            }
  })

   }


   getAllAccessLog()


const loading = ref(false); 
    const selectedKeys = ref([]);

    const pagePayLog = reactive({ current: 1, limit: 10, total: 0 });

    const columnsPayLog = ref([ 
      { title:"平台", width: "80px", key:"platformId",align:"center" },
      { title:"账号", key:"userName" ,align:"center" }, 
      { title:"订单编号", key:"orderid" ,align:"center" }, 
      { title:"金额", width: "120px", key:"amount", sort: "desc" ,align:"center" },  
      { title:"时间", key:"dateTime" ,align:"center"},
     
    ]);

    const changePayLog = (page:any) => {
        getAllPayLog()
    }

    const sortChange = (key:any, sort:any) => {
      layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
    }

    const payLogdataSource = ref( )

   const  getAllPayLog=()=>{
    var data = { "page": pagePayLog.current, "limit": pagePayLog.limit, "state": 2};
    allPayLog(data).then((res: any) => {
    if (res != "" && res.code == 0) {  
        payLogdataSource.value=res.data

        pagePayLog.total = res.count;
        loading.value = false;
 
        
    }else {
        payLogdataSource.value = [];
        pagePayLog.total = 0;
              loading.value = false;
            }
  })

   }


   getAllPayLog()

 

 

return (_ctx: any,_cache: any) => {
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_table = _resolveComponent("lay-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_1,
                  _createElementVNode("div", _hoisted_2, _toDisplayString(statistics.newUser), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", null, _toDisplayString(statistics.totalUsers), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, _toDisplayString(statistics.newMember), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", null, _toDisplayString(statistics.totalMembers), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(statistics.todayEarnings), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", null, _toDisplayString(statistics.totalRevenue), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(statistics.rechargeSuccessful), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", null, _toDisplayString(statistics.rechargeFailed), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(statistics.pendingReview), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", null, _toDisplayString(statistics.auditFailure), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, _toDisplayString(statistics.todayLoufeng), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", null, _toDisplayString(statistics.generalLoufeng), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_table, {
                  page: pagePayLog,
                  height: '100%',
                  columns: columnsPayLog.value,
                  loading: loading.value,
                  "default-toolbar": false,
                  "data-source": payLogdataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                  size: "sm",
                  onChange: changePayLog,
                  onSortChange: sortChange
                }, {
                  toolbar: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_table, {
                  page: pageAccess,
                  height: '100%',
                  columns: columnsAccess.value,
                  loading: loading.value,
                  "default-toolbar": false,
                  "data-source": accessdataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  size: "sm",
                  onChange: changeAccess,
                  onSortChange: sortChange
                }, {
                  toolbar: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})